module.exports = __webpack_public_path__ + "media/images/success-stories-2-6497e00ec2d0dd2fce575178e2302aa2.jpeg";